import { navigateTo } from '@cat-ecom/common/utils/browserUtils';
import {
  NO_SEARCH_RESULTS,
  PCC_MY_EQUIPMENT_PAGE,
  SEARCH_MY_EQUIPMENT,
  STATUS_FAIL,
  STATUS_SUCCESS
} from 'constants/analyticsConstants';
import { selectEquipment } from 'services/equipment/actions';
import { Equipment } from 'services/equipment/types';

export const getDesktopImageWidthHeight = (isDesktop) => {
  return {
    imgWidth: isDesktop ? 269 : 141,
    imgHeight: isDesktop ? 191 : 100
  };
};

export const searchMyEquipmentGATracking = (
  search: string,
  equipments: Equipment[]
) => {
  const eventContent = {
    formName: SEARCH_MY_EQUIPMENT,
    formContent: search,
    formContent2: '',
    formLocation: PCC_MY_EQUIPMENT_PAGE
  };
  if (search && equipments?.length > 0) {
    eventContent['formStatus'] = STATUS_SUCCESS;
  } else if (search && equipments.length === 0) {
    eventContent['formStatus'] = STATUS_FAIL;
    eventContent['formFieldCausingError'] = NO_SEARCH_RESULTS;
  }
  return eventContent;
};

export const redirectFromEquipment = async (
  url: string,
  isSelectedEquipment: boolean,
  equipmentDetails: {
    id: string;
    serialNumber: string;
  }
) => {
  const response =
    !isSelectedEquipment &&
    (await selectEquipment(
      equipmentDetails?.id,
      equipmentDetails?.serialNumber,
      false
    ));

  if (isSelectedEquipment || response.ok) {
    navigateTo(url);
  }
};
